import { memo, useMemo } from 'react'
import { Mail } from 'lucide-react'
import { fromNow } from '@/utils/dayjs'
import type { TNovuMessage } from '@/interfaces/notification'

type Props = {
  notification: TNovuMessage
}

const MenuNotificationItem = ({ notification }: Props) => {
  const date = useMemo(() => fromNow(notification.createdAt), [ notification ])
  return (
    <div className="flex items-start gap-4">
      <div className="bg-ghost relative flex-none rounded-full p-3">
        <Mail size={14} className="text-background" />
        <div className="absolute top-0 left-0 flex items-center">
          {!notification.seen && (
            <div className="bg-destructive h-2 w-2 rounded-full" />
          )}
        </div>
      </div>
      <div className="flex-1">
        <h5 className="custom-ellipsis text-bold mb-1 line-clamp-1 text-xs md:text-sm">
          {notification.payload.title}
        </h5>
        <p className="text-ghost mb-0 text-xs">{date}</p>
      </div>
    </div>
  )
}

export default memo(MenuNotificationItem)
